export type ObjectProfileBackWall = 'top' | 'bottom' | 'left' | 'right';

export type ObjectProfileOrientation = {
  backWall: ObjectProfileBackWall;
  localSize: [number, number, number];
  facingYRad: number;
};

function normalizedBackWall(value: unknown): ObjectProfileBackWall {
  const side = String(value || 'top').trim().toLowerCase();
  if (side === 'bottom' || side === 'left' || side === 'right') return side;
  return 'top';
}

/**
 * Resolve one aggregate transform for a normalized object profile.
 *
 * Profiles are authored with their back at local Z=0. Side-facing objects use
 * the world depth as local width before the root group is rotated, preserving
 * the original world envelope without rotating each child a second time.
 */
export function resolveObjectProfileOrientation(
  size: [number, number, number],
  requestedBackWall: unknown,
): ObjectProfileOrientation {
  const backWall = normalizedBackWall(requestedBackWall);
  const localSize: [number, number, number] = backWall === 'left' || backWall === 'right'
    ? [size[2], size[1], size[0]]
    : [...size];
  const facingYRad = backWall === 'bottom'
    ? Math.PI
    : backWall === 'left'
      ? Math.PI / 2
      : backWall === 'right'
        ? -Math.PI / 2
        : 0;
  return { backWall, localSize, facingYRad };
}
